import {retrieveContentfulImage} from "../common/image";

export const getImageWithExpandableData = (componentData) => {
    const data = {};
    data.title = componentData?.fields?.title;
    data.subtitle = componentData?.fields?.subtitle;
    data.richText = componentData?.fields?.elements?.[0]?.fields?.richText;
    data.imageTitle = componentData?.fields?.image?.fields?.title;
    const imageUrl = componentData?.fields?.image?.fields?.file?.url;
    if (imageUrl) {
        data.imageUrl = retrieveContentfulImage(imageUrl, {width: 640, height: 480, fit: "fill", focus: "face"});
    }

    return data;
};
